import React from "react";
import { Navigate } from "react-router-dom";

import Forbidden403 from "../pages/Adatis/Shared/Forbidden403";
import { userHasAnyRole } from "../services/authService";
import { getDefaultHomePathForRoles } from "./roleAccess";

interface RoleGuardProps {
  allowedRoles: string[];
  children: React.ReactNode;
  redirectOnDeny?: boolean;
}

const RoleGuard = ({
  allowedRoles,
  children,
  redirectOnDeny = false,
}: RoleGuardProps) => {
  if (userHasAnyRole(allowedRoles)) {
    return <>{children}</>;
  }

  if (redirectOnDeny) {
    return <Navigate to={getDefaultHomePathForRoles()} replace />;
  }

  return <Forbidden403 />;
};

export default RoleGuard;
